import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { ReservaSchema, ReservasPaginadasSchema, InscripcionSchema, } from '@/data/dto/reserva';
import { z } from 'zod';
export const reservasApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.reservas, {
            params: {
                sucursalId: filtros.sucursalId,
                clienteId: filtros.clienteId,
                estado: filtros.estado,
                fechaClase: filtros.fechaClase,
                fechaClaseDesde: filtros.fechaClaseDesde,
                fechaClaseHasta: filtros.fechaClaseHasta,
                creadoDesde: filtros.creadoDesde,
                creadoHasta: filtros.creadoHasta,
                q: filtros.q,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
            },
        });
        return ReservasPaginadasSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.reservas}/${id}`);
        return ReservaSchema.parse(res.data);
    },
    async crear(values) {
        const payload = {
            clienteId: values.clienteId,
            sucursalId: values.sucursalId,
            promotorId: values.promotorId || null,
            empleadoSolicitadoId: values.empleadoSolicitadoId || null,
            metodoPagoPrevisto: values.metodoPagoPrevisto,
            observaciones: values.observaciones || null,
            canal: 'GESTION',
        };
        const res = await apiClient.post(ENDPOINTS.reservas, payload);
        return ReservaSchema.parse(res.data);
    },
    async editar(id, values) {
        const payload = {
            promotorId: values.promotorId,
            empleadoSolicitadoId: values.empleadoSolicitadoId,
            metodoPagoPrevisto: values.metodoPagoPrevisto,
            observaciones: values.observaciones ?? null,
        };
        const res = await apiClient.patch(`${ENDPOINTS.reservas}/${id}`, payload);
        return ReservaSchema.parse(res.data);
    },
    async agregarClase(reservaId, datos) {
        const res = await apiClient.post(`${ENDPOINTS.reservas}/${reservaId}/clases`, {
            tarifaId: datos.tarifaId,
            meetingPointId: datos.meetingPointId,
            empleadoId: datos.empleadoId || null,
            fechaHoraInicio: datos.fechaHoraInicio,
            cantPersonas: datos.cantPersonas ?? null,
        });
        return InscripcionSchema.parse(res.data.inscripcion);
    },
    async confirmar(id) {
        const res = await apiClient.post(`${ENDPOINTS.reservas}/${id}/confirmar`);
        return ReservaSchema.parse(res.data);
    },
    async cancelar(id, motivo) {
        const res = await apiClient.post(`${ENDPOINTS.reservas}/${id}/cancelar`, {
            motivo: motivo ?? null,
        });
        return ReservaSchema.parse(res.data);
    },
    async listarInscripciones(id) {
        const res = await apiClient.get(`${ENDPOINTS.reservas}/${id}/clases`);
        return z.object({ items: z.array(InscripcionSchema) }).parse(res.data).items;
    },
};
